import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DeveloperWorkbenchCoreComponent } from '@workspace/ng-core-features';

@Component({
  selector: 'admin-root',
  imports: [RouterOutlet, DeveloperWorkbenchCoreComponent],
  host: {
    // Ensure root component fills the entire viewport
    class: 'flex min-h-full w-full flex-auto flex-col',
  },
  template: `
    <router-outlet />
    <core-developer-workbench />
  `,
})
export class AppAdminComponent {}
